import {Directive, ElementRef, forwardRef, Input, OnDestroy, TemplateRef} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import {Placement} from '@popperjs/core';
import {DynamicComponentRef} from '../dynamic-component';
import {ModalService} from '../modal';
import {createPopperDropdownOffsetModifier} from '../popper-utils/modifiers/popper-dropdown-offset';
import {PopperOptions} from '../popper-utils/popper-options';
import {TemplateDropdownComponent} from './template-dropdown.component';

@Directive({
    selector: '[templateDropdown]',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => TemplateDropdownDirective),
            multi: true
        }
    ],
    standalone: false
})
export class TemplateDropdownDirective implements ControlValueAccessor, OnDestroy {

    @Input()
    public target: ElementRef;

    @Input()
    public placement: Placement = 'bottom';

    @Input()
    public popperOptions: PopperOptions;

    public isVisible: boolean;

    private dropdownRef: DynamicComponentRef<any>;

    private propagateChange: (isVisible: boolean) => void;

    constructor(
        private templateRef: TemplateRef<any>,
        private modalService: ModalService
    ) {}

    public registerOnChange(onChange: (isVisible: boolean) => void): void {
        this.propagateChange = onChange;
    }

    public registerOnTouched(fn: any): void {
        // Not implemented
    }

    public writeValue(isVisible: boolean): void {
        this.isVisible = !!isVisible;
        this.updateByIsVisible(this.isVisible);
    }

    public ngOnDestroy(): void {
        this.destroyPopup();
    }

    private updateByIsVisible(isVisible: boolean): void {
        if (isVisible) {
            if (!this.dropdownRef) {
                this.dropdownRef = this.modalService.open(TemplateDropdownComponent, {
                    onDestroy: () => this.handleClosed(),
                    configure: {
                        targetElement: this.target,
                        templateRef:   this.templateRef,
                        placement:     this.placement,
                        popperOptions: {
                            modifiers: [
                                createPopperDropdownOffsetModifier()
                            ],
                            ...this.popperOptions
                        }
                    }
                });
            }
        } else {
            this.destroyPopup();
        }
    }

    private destroyPopup(): void {
        if (this.dropdownRef) {
            this.dropdownRef.destroy();
            this.dropdownRef = undefined;
        }
    }

    private handleClosed(): void {
        this.dropdownRef = undefined;
        this.isVisible = false;
        this.propagateChange(this.isVisible);
    }

}
